module.exports = __webpack_public_path__ + "img/jiapiao.098c6bed.png";